<template>
  <div class="map-faker">
    <transition name="slide-horizontally">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { SET_HERO_ANIMATION, SET_VIDEO_LOADED } from '@/store/mutation-types'

export default {
  created () {
    this.setHeroAnimation()
    this.setVideoLoaded()
  },
  methods: {
    ...mapMutations({
      setHeroAnimation: SET_HERO_ANIMATION,
      setVideoLoaded: SET_VIDEO_LOADED
    })
  }
}
</script>

<style lang="scss" scoped>
  .map-faker {
    z-index: z(details);
    position: fixed;
  }
</style>



// WEBPACK FOOTER //
// src/views/MapFaker.vue